import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import useSignout from '../../../../hooks/Authentication/useSignout';

function Index() {
  const signout = useSignout();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 2,
        padding: 4,
        minHeight: '50vh',
      }}
    >
      <Typography variant="h5">Access Denied</Typography>
      <Typography variant="body1" color="text.secondary">
        You currently do not have access to this page. Please contact Baltimore Life Agent Relations
        at (877) 533-2468 for more information.
      </Typography>
      <Typography variant="body1" color="text.secondary">
        If your permissions have been updated, you must sign out for new permissions to take effect.
      </Typography>
      <Button variant="contained" onClick={signout}>
        Sign Out
      </Button>
    </Box>
  );
}

export { Index };
